import { useId, useState, type FormEvent } from "react";

export type SearchRequestInput = {
  query: string;
  ruleDate: string;
  attributes: Record<string, string | number | boolean>;
};

type SearchFormProps = {
  defaultRuleDate: string;
  pending: boolean;
  onSubmit: (request: SearchRequestInput) => void;
};

export function SearchForm({ defaultRuleDate, pending, onSubmit }: SearchFormProps) {
  const inputId = useId();
  const dateId = useId();
  const [query, setQuery] = useState("");
  const [ruleDate, setRuleDate] = useState(defaultRuleDate);

  function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const trimmedQuery = query.trim();
    if (!trimmedQuery) return;
    const attributes: SearchRequestInput["attributes"] = { originCountry: "CN" };
    const form = new FormData(event.currentTarget);
    for (const key of ["material", "function", "use", "exporterOrProducer"] as const) {
      const value = String(form.get(key) ?? "").trim();
      if (value) attributes[key] = value;
    }
    onSubmit({ query: trimmedQuery, ruleDate: ruleDate || defaultRuleDate, attributes });
  }

  return (
    <form className="search-panel" onSubmit={submit} role="search">
      <div className="search-panel-heading">
        <div>
          <p className="eyebrow">商品查询</p>
          <h3>输入品名或 HS 编码</h3>
        </div>
        <span className="origin-chip" aria-label="固定原产国：中国">原产国：中国</span>
      </div>
      <div className="search-action-row">
        <div className="search-field search-field-primary">
          <label htmlFor={inputId}>中文品名或编码</label>
          <input
            id={inputId}
            name="query"
            type="search"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="例如：乳胶床垫 / 940421"
            autoComplete="off"
            required
            aria-describedby={`${inputId}-hint`}
          />
        </div>
        <button className="primary-button" type="submit" disabled={query.trim().length === 0}>
          {pending ? "查询中…" : "查询"}
        </button>
      </div>
      <div className="search-meta-row">
        <div className="search-field search-date-field">
          <label htmlFor={dateId}>规则日期</label>
          <input id={dateId} name="ruleDate" type="date" value={ruleDate} onChange={(event) => setRuleDate(event.target.value)} required />
        </div>
        <p className="support-note" id={`${inputId}-hint`}>材质、功能和用途越明确，归类候选越可靠。</p>
      </div>
      <details className="structured-fields">
        <summary>补充商品信息（提高归类准确性）</summary>
        <div className="search-attribute-grid">
          <label>
            材质/成分
            <input name="material" maxLength={120} placeholder="例如：304 不锈钢、ABS 塑料" />
          </label>
          <label>
            功能
            <input name="function" maxLength={120} placeholder="例如：真空保温、支撑固定" />
          </label>
          <label>
            最终用途
            <input name="use" maxLength={120} placeholder="例如：家用盛装饮料、工业设备零件" />
          </label>
          <label>
            生产商/出口商
            <input name="exporterOrProducer" maxLength={120} placeholder="选填，仅留在复核结果中" />
          </label>
        </div>
      </details>
    </form>
  );
}
